module.exports = __webpack_public_path__ + "img/1.aa678c49.jpg";